<script setup lang="ts">
import { ref, computed, type Component } from 'vue';
import { useQuizStore } from '../../../../stores';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../../configs/text';

import ButtonV2 from '../../../General/ButtonV2.vue';
import QuizMutipleChoice from './patterns/QuizMutipleChoice.vue'
import QuizFillinBlank from './patterns/QuizFillInBlank.vue'
import QuestionNav from '../../../Assessment/QuestionNav.vue';
import Slide from '../../../Animation/Slide.vue';
import QuizBGMVolumeControl from './components/QuizBGMVolumeControl.vue';

interface IComponents {
    [key: string]: Component
}
const components: IComponents = {
    'mca': QuizMutipleChoice,
    'sca': QuizMutipleChoice,
    'gap': QuizFillinBlank
}

const { t } = useI18n()

const quizStore = useQuizStore();
const slideDirection = ref<'left' | 'right'>('left')
const curentQuizIndex = ref<number>(0)
const curentQuiz = computed(() => {
    return quizStore.quiz?.questions[curentQuizIndex.value]
})
function changeQuestion(index: number) {
    slideDirection.value = curentQuizIndex.value < index ? 'left' : 'right'
    curentQuizIndex.value = index
}
</script>

<template>
    <div class="relative flex flex-col justify-between h-full w-full overflow-hidden" v-if="curentQuiz?.id">
        <div class="flex flex-col w-full h-full gap-5 overflow-hidden">
            <Slide :direction="slideDirection">
                <component :is="components[curentQuiz.questionType as keyof typeof components]" :question="curentQuiz"
                    :showAnswer="false" :showSubmission="false" :key="curentQuiz.id" disabled></component>
            </Slide>
        </div>
        <div class="flex gap-3 sm:flex-row justify-between items-center w-full bg-white px-5 py-3 rounded-lg">
            <div class="flex items-center gap-3">
                <QuizBGMVolumeControl class="text-black dark:text-zinc-700 size-10" />
                <div class="hidden sm:flex md:flex-col gap-1 items-center font-bold">
                    <p class="text-orange-500 dark:text-rose-600">{{ t(TEXT.points) }}</p>
                    <p class="text-black dark:text-zinc-700">{{ curentQuiz.point }}</p>
                </div>
            </div>

            <QuestionNav :darkMode="quizStore.darkMode" :current="curentQuizIndex"
                :total="quizStore.quiz?.questions.length" @change="changeQuestion" />
            <div class="flex items-center justify-center gap-3">
                <ButtonV2 :color="quizStore.darkMode ? 'danger' : 'info'" animation
                    @click="quizStore.previewQuiz = false">{{ t(TEXT.close_btn) }}
                </ButtonV2>
            </div>
        </div>
    </div>
</template>
